import React from 'react';
import { useGoogleLogin  } from '@react-oauth/google';
import { Box, Button } from '@mui/material';
import CloudIcon from '@mui/icons-material/Cloud';

const GoogleDriveAuth = ({ onAuthSuccess }) => {
  const login = useGoogleLogin({
    scope: 'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/spreadsheets.readonly',
    onSuccess: (tokenResponse) => {
      onAuthSuccess({
        accessToken: tokenResponse.access_token,
        expiresIn: tokenResponse.expires_in,
      });
    },
    onError: () => {
      console.error('❌ Erreur lors de la connexion à Google');
    }
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
      <Button
        variant="contained"
        startIcon={<CloudIcon />}
        onClick={() => login()}
      >
        Connexion à Google Drive
      </Button>
    </Box>
  );
};

export default GoogleDriveAuth;
